import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IonicModule} from '@ionic/angular';

@Component({
  selector: 'app-pagination-control',
  templateUrl: './pagination-control.component.html',
  styleUrls: [],
  standalone: true,
  imports: [
    IonicModule
  ]
})
export class PaginationControlComponent {
   @Input() currentPage: number;
   @Input() totalPages: number;

   @Output() nextPage: EventEmitter<number> = new EventEmitter<number>();
   @Output() prevPage: EventEmitter<number> = new EventEmitter<number>();
   @Output() firstPage: EventEmitter<void> = new EventEmitter<void>();
   @Output() lastPage: EventEmitter<number> = new EventEmitter<number>();
}
